module.exports = __webpack_public_path__ + "img/1f237e1.png";